function getNodeFromLocationPath(location, number) {
    var path = location.pathname.split('/');
    if (path.length > number)
        return path[number];
    return null;
}

module.exports = {
    getNodeFromLocationPath
};